"use strict";

require("core-js/modules/es.array.reduce.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _rxjs = require("rxjs");

var _operators = require("rxjs/operators");

var _identity = _interopRequireDefault(require("lodash/identity"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

var errorPayload = function errorPayload(_ref) {
  var code = _ref.code,
      message = _ref.message;
  return {
    code: code,
    message: message
  };
};

var resolveRequest = function resolveRequest() {
  return (0, _operators.mergeMap)(function (_ref2) {
    var _ref2$payload = _ref2.payload,
        response = _ref2$payload.response,
        responseActions = _ref2$payload.responseActions;
    return (0, _rxjs.from)(response()).pipe((0, _operators.map)(function (data) {
      return responseActions.map(function (_ref3) {
        var action = _ref3.action,
            _ref3$succeededPayloa = _ref3.succeededPayload,
            succeededPayload = _ref3$succeededPayloa === void 0 ? _identity["default"] : _ref3$succeededPayloa;

        if (action !== null && action !== void 0 && action.succeeded) {
          return action.succeeded(succeededPayload(data));
        }

        return typeof action === 'function' ? action(succeededPayload(data)) : action;
      });
    }), (0, _operators.mergeAll)(), (0, _operators.catchError)(function (error) {
      return responseActions.reduce(function (failedActions, _ref4) {
        var action = _ref4.action,
            _ref4$failedPayload = _ref4.failedPayload,
            failedPayload = _ref4$failedPayload === void 0 ? errorPayload : _ref4$failedPayload;
        return action !== null && action !== void 0 && action.failed ? [].concat(_toConsumableArray(failedActions), [action.failed(failedPayload(error))]) : failedActions;
      }, []);
    }));
  });
};

var _default = resolveRequest;
exports["default"] = _default;